import { PlatformEnvironment } from '@mews/enums';
import { customWorkspaceAllowedEnvs, GDProduct } from './const';
import type { GoodDataService } from './goodDataService';
import { GoodDataParameters } from './types';

const createGDServiceForProduct = async (product: GDProduct, goodDataParameters: GoodDataParameters) => {
    const { createGoodDataService } = await import(/* webpackChunkName: "goodData" */ './goodDataService');
    const workspaceId =
        product === GDProduct.MewsBI ? goodDataParameters.biWorkspaceId : goodDataParameters.workspaceId;

    return createGoodDataService({
        hostname: goodDataParameters.baseUrl,
        getToken: () => goodDataParameters.userToken,
        getWorkspace: () => workspaceId,
    });
};

export const getGDServiceForProduct = (() => {
    const gdServices = new Map<GDProduct, GoodDataService>();
    return async (product: GDProduct, goodDataParameters: GoodDataParameters) => {
        if (gdServices.has(product)) return gdServices.get(product) as GoodDataService;
        const service = await createGDServiceForProduct(product, goodDataParameters);
        gdServices.set(product, service);
        return service;
    };
})();

interface GetWorkspaceIdParams {
    environment: PlatformEnvironment;
    goodDataParameters: GoodDataParameters;
    product: GDProduct;
    workspaceId?: string;
}

export const getWorkspaceId = ({
    environment,
    goodDataParameters,
    product,
    workspaceId: testingWorkspaceId,
}: GetWorkspaceIdParams) => {
    if (testingWorkspaceId && customWorkspaceAllowedEnvs.includes(environment)) {
        return testingWorkspaceId;
    }

    if (product === GDProduct.MewsBI) {
        return goodDataParameters.biWorkspaceId || undefined;
    }
    return goodDataParameters.workspaceId;
};
